module.exports = __webpack_public_path__ + "static/media/light.abf5aa80.mp3";